import * as React from 'react';

export interface Props {
  title: React.ReactNode;
}

export class PortalAsideHeading extends React.Component<Props, {}> {
  render() {
    const { title } = this.props;

    return (
      <li className="menu-section">
        <h4 className="menu-text">{title}</h4>
        <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
      </li>
    );
  }
}
